import React, { useContext, useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";

import { ContainerBlock } from "../../styles";
import {
  brandLogo,
  brandLogoSm,
  cartStroke,
  chatSvg,
  exitSvg,
  filterLines,
  menuBarsSvg,
  menuBurger,
  mobileHomeSvg,
  settingsSvg,
  timeStroke,
  userFill,
} from "../../svgs";
import Portal from "../portals";
import LoginModal from "../portals/loginModal";
import UpdatePasswordModal from "../portals/updatePassword";

import RegisterModal from "../portals/registerModal";
import NotificationInfo from "../portals/notificationInfo";
import PortalContext from "../../context/portalContext";
import DataContext from "../../context/dataContext";
import { useGetUserInfo, useLogoutUser } from "../../apiHooks/auth";
import LoaderCircle from "../loader";

import {
  StyledHeader,
  HeaderMain,
  CategoryBtn,
  AuthBtns,
  DropdownsBackground,
  MobileNav,
} from "./styled";
import SearchForm from "./search";
import TimeFilter from "./filter";
import CategoryDropdown from "./categories";

export default function Header() {
  const { t } = useTranslation();

  const location = useLocation();
  const {
    loginPortal,
    openLogin,
    closeAuthPortals,
    registerPortal,
    updatePasswordPortal,
  } = useContext(PortalContext);
  const { user, auth, setAuth, setUserData, errors, successMsgs } =
    useContext(DataContext);

  // console.log(auth, user);

  const [background, setBackground] = useState(false);
  const [categoriesOpen, setCategories] = useState(false);
  const [filterOpen, setFilter] = useState(false);
  const [AccountMenuOpen, setAccountMenu] = useState(false);

  const handleCategoriesOpen = () => {
    if (categoriesOpen) {
      setCategories(false);
    } else {
      setCategories(true);
      setAccountMenu(false);
      setFilter(false);
    }
  };
  const handleFilterOpen = () => {
    if (filterOpen) {
      setFilter(false);
    } else {
      setFilter(true);
      setCategories(false);
      setAccountMenu(false);
    }
  };
  const handleAccountOpen = () => {
    if (AccountMenuOpen) {
      setAccountMenu(false);
    } else {
      setAccountMenu(true);
      setCategories(false);
      setFilter(false);
    }
  };
  const closeAll = () => {
    setBackground(false);
    setAccountMenu(false);
    setCategories(false);
    setFilter(false);
  };

  // watch for popups
  useEffect(() => {
    if (categoriesOpen || filterOpen || AccountMenuOpen) {
      document.querySelector("body").classList.add("fixed");
      setBackground(true);
      closeAuthPortals();
    } else {
      closeAll();
      document.querySelector("body").classList.remove("fixed");
    }
  }, [categoriesOpen, filterOpen, AccountMenuOpen]);
  // close  popup modals  if auth protal is open
  useEffect(() => {
    if (loginPortal) closeAll();
  }, [loginPortal]);

  // close evrything on routechange +  prevent same scroll y position on route change
  useEffect(() => {
    closeAll();
    document.querySelector("body").classList.remove("fixed");
    window.scrollTo(0, 0);
  }, [location]);

  // zoho chat
  const openChat = () => {
    console.log("chat");
  };
  const changeLanguage = (val) => {
    // i18n.changeLanguage("ka");
    i18n.changeLanguage(val);
  };
  //  AuthORIZATION related > autologin > logout
  const [refetchUser, setRefetchUser] = useState(false);
  const {
    data,
    isSuccess: isUserSuccess,
    isLoading,
    refetch,
  } = useGetUserInfo();

  useEffect(() => {
    const token = window.localStorage.getItem("access-token");
    if (data?.data.username && isUserSuccess && token) {
      setUserData(data.data);
      setAuth(true);
    }
  }, [isUserSuccess, data]);

  // refetch userinfo on auth=true
  useEffect(() => {
    if (auth && !user?.username) {
      refetch();
    }
  }, [auth]);

  const { logoutUser, status: logoutStatus } = useLogoutUser();
  useEffect(() => {
    if (logoutStatus === "success") {
      closeAll();
      setUserData({});
      setAuth(false);
    }
  }, [logoutStatus]);

  return (
    <>
      {loginPortal && <Portal component={<LoginModal />} />}
      {updatePasswordPortal && <Portal component={<UpdatePasswordModal />} />}
      {registerPortal && <Portal component={<RegisterModal />} />}
      {errors.length || successMsgs.length ? (
        <Portal component={<NotificationInfo />} />
      ) : null}

      {/* mobile nav */}
      <MobileNav>
        <Link
          to="/"
          className={`nav-item ${location.pathname === "/" ? " active" : ""} `}
        >
          {mobileHomeSvg()} <h4>მთავარი</h4>
        </Link>

        <button
          className={`nav-item ${categoriesOpen ? " active" : ""} `}
          onMouseUp={handleCategoriesOpen}
        >
          {menuBarsSvg()}
          <h4>კატეგორიები</h4>
        </button>

        <button
          className={`nav-item ${filterOpen ? " active" : ""} `}
          onMouseUp={handleFilterOpen}
        >
          {filterLines()} <h4>ფილტრი</h4>
        </button>

        {auth ? (
          <button
            className={`nav-item ${AccountMenuOpen ? "active" : ""}`}
            onMouseUp={handleAccountOpen}
          >
            {userFill()} <h4>ჩემი ველი</h4>
          </button>
        ) : (
          // <a href="https://veli.store/" target="_blank" rel="noreferrer" className="nav-item" >
          //     {userFill()}
          //     <h4>ჩემი ველი</h4>
          // </a>
          <button onClick={openLogin} className="nav-item profile">
            {userFill()}
            <h4> შესვლა</h4>
          </button>
        )}
      </MobileNav>

      <StyledHeader>
        <ContainerBlock>
          <HeaderMain>
            <Link to="/" className="brand-link">
              {brandLogo()}
              {brandLogoSm()}
            </Link>

            <CategoryBtn onMouseUp={handleCategoriesOpen}>
              {menuBurger()}
              {t("categories")}
            </CategoryBtn>

            <SearchForm close={closeAll} />

            <TimeFilter open={filterOpen} toggleMenu={handleFilterOpen} />

            <AuthBtns>
              {isLoading ? (
                <button className="btn">
                  {userFill()} <LoaderCircle />
                </button>
              ) : !auth ? (
                <button className="btn" onMouseUp={openLogin}>
                  {userFill()} შესვლა
                </button>
              ) : (
                <button className="btn" onMouseUp={handleAccountOpen}>
                  {userFill()} ჩემი ველი
                </button>
              )}
              {/* account menu */}
              <div
                className={`dropdown ${AccountMenuOpen && auth ? "open" : ""}`}
              >
                <div className="header">
                  <div className="headline">
                    გამარჯობა {user?.username?.split(" ")[0]}
                  </div>
                  {/* <button>{chatSvg()}მოგვწერე</button> */}
                </div>

                <nav className="nav">
                  <a
                    href="https://veli.store/"
                    target="_blank"
                    className="nav-item"
                    rel="noreferrer"
                  >
                    {cartStroke()}
                    განაგრძე შოპინგი
                  </a>
                  <a
                    href="https://veli.store/profile/account/"
                    className="nav-item"
                  >
                    {settingsSvg()}
                    პარამეტრები
                  </a>
                </nav>

                <button className="logout" onMouseUp={logoutUser}>
                  {exitSvg()}
                  გამოსვლა
                </button>
              </div>
            </AuthBtns>

            {/* <button className="chat-btn" onMouseUp={openChat}>
              {chatSvg()}
            </button> */}
          </HeaderMain>
        </ContainerBlock>

        {/* categories */}
        <CategoryDropdown open={categoriesOpen} />

        {/* transparent background for dropdowns */}
        <DropdownsBackground shown={background} onMouseUp={closeAll} />
      </StyledHeader>
    </>
  );
}
